import { BaseFetch } from "../main-model"
export default class ReportLearningResModel extends BaseFetch {
    getReportLearningResBy = (data) =>
    this.authFetch({
      url: "report-learning-res/getReportLearningResBy",
      method: "POST",
      body: JSON.stringify(data),
    })
}
